import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";

const PlotMapping = (props) => {
  const frmRef = useRef({});
  const navigate = useNavigate();
 const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();

  const [stateData, setStatedata] = useState([]);

  const [stateId, setStateId] = useState();
  const [stateName, setStateName] = useState();

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getPlotMappingData } = useHttp();

  const fillPlotMappingData = (employeeId, regionId, farmerNo) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId != "0" && employeeId != "") {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerPlotReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getPlotMappingData(
      {
        url: url,
      },
      (res) => {
        console.log("reportdata", res.data);
        setData(res.data);
      }
    );
  };

  useEffect(() => {
    fillPlotMappingData(0, 0, "");
  }, [getPlotMappingData]);

  const fieldsToExport = [
    "farmerId",
    "mappingDate",
    "farmerName",
    "farmerNo",
    "plotId",
    "plotArea",
    "executiveName",
    "state",
    "landOwnership",
    "farmerAddress",
    "landPreparationType",
    "soilType",
    "irrigationSource",
    "latitude",
    "longitude",
    "landMark",
    "createdDate",
  ];

  const customHeaders = [
    "Farmer Id",
    "Registration Date",
    "Farmer Name",
    "Farmer Code",
    "Plot Id",
    "Farm Size",
    "User Name",
    "State",
    "Land Ownership",
    "Farm Address/Farm Location",
    "Land Preparation Type",
    "SoilType",
    "Irrigation Source",
    "Latitude",
    "Longitude",
    "LandMark",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "PlotMapping.xlsx";
    console.log(fieldsToExport, customHeaders);

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");
      console.log("createdDate: item.createdDate", item.createdDate)
      return {
        ...item,
        latitude,
        longitude,
        createdDate: item.createdDate
          ? new Date(item.createdDate).toLocaleDateString("en-GB")
          : "",
      };
    });

    console.log("Processed Data:", processedData);
    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  const exportToExcel = () => {
    const filename = "PlotMapping_With_Images.xlsx";

    const processedData = data.map((item) => {
      const coordinates = JSON.parse(item.plotCoordinates || "[]");
      const latitude = coordinates.map((coord) => coord.latitude).join(", ");
      const longitude = coordinates.map((coord) => coord.longitude).join(", ");

      let imageUrl = "No Image";
      if (item.plotPhotosUrls) {
        const urls = JSON.parse(item.plotPhotosUrls);
        if (urls.length > 0 && urls[0]) {
          imageUrl = `${process.env.REACT_APP_FILE_URL}${urls[0]}`;
        }
      }

      return {
        ...item,
        latitude,
        longitude,
        plotPhotosUrls: imageUrl, // Only first image URL
        createdDate: item.createdDate
          ? new Date(item.createdDate).toLocaleDateString("en-GB")
          : "",
      };
    });

    const fieldsToExportWithImages = [...fieldsToExport, "plotPhotosUrls"];
    const customHeadersWithImages = [...customHeaders, "Plot Image URL"];

    convertToExcel(
      processedData,
      fieldsToExportWithImages,
      filename,
      customHeadersWithImages
    );
  };

  const { sendRequest: postExportToExcel } = useHttp();

  // const exportToExcel = (e, includeImages) => {
  //   e.preventDefault();

  //   const data = {
  //     stateName: stateName,
  //     fieldExecutiveId: employeeId,
  //     farmerNo: farmerNumber,
  //     fromDate: showDateFilter ? selectedFromDate : "",
  //     toDate: showDateFilter ? selectedToDate : "",
  //     orgId: parseInt(localStorage.getItem("orgId")),
  //     empId: parseInt(localStorage.getItem("empId")),
  //     includeImages: includeImages,
  //   };
  //   postExportToExcel(
  //     {
  //       url: `/api/excelPlotMapping/`,
  //       method: "POST",
  //       body: data,
  //     },
  //     (data) => {
  //       toast.success(`You will receive your Excel file on your email shortly`);
  //     },
  //     (error) => {
  //       toast.error("Error...");
  //     }
  //   );
  // };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var urlfilter = "";
    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
      },
      (data) => {
        setFarmerNumber("");
        setFarmerData(data);
      }
    );
  }, [employeeId, stateName]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Plot Mapping Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        // console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillPlotMappingData(employeeId, regionId, farmerNumber);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              {/* <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button> */}
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={(e) => handleExportExcel(e, false)}
                // onClick={(e) => exportToExcel(e, false)}
              >
                <i className="fas fa-file-excel"></i> Excel File Without Images
              </button>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={(e) => exportToExcel(e, true)}
              >
                <i className="fas fa-file-excel"></i> Excel File With Images
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          {/* <th>Farmer Id</th> */}
                          <th>Farmer No</th>
                          <th>Plot Photos</th>
                          <th>Registration Date</th>
                          <th>Farmer Name</th>
                          <th>Plot Name</th>
                          <th>Plot Id</th>
                          <th>Plot Size(Ha)</th>
                          <th>User Name</th>
                          <th>State</th>
                          <th>Land Ownership</th>
                          <th>Farmer Address/Farm Location</th>
                          <th>Land Preparation Type</th>
                          <th>Soil Type</th>
                          <th>Soil Texture</th>
                          <th>Irrigation Source</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th>Land Mark</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                {/* <td>{itm.farmerNo}</td> */}
                                <td>{itm.farmerNo}</td>
                                <td>
                                  {itm.plotPhotosUrls ? (
  JSON.parse(itm.plotPhotosUrls)
    .filter(url => url) // remove empty/falsy URLs
    .map((url, index) => (
      <img
        src={`${process.env.REACT_APP_FILE_URL}${url}`}
        key={index}
        className="plot-image img-square"
        width="100"
        height="100"
        alt=""
      />
    ))
) : (
  "No Images"
)}

                                </td>
                                <td>
                                  {new Date(
                                    itm.mappingDate
                                  ).toLocaleDateString()}
                                </td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.plotName}</td>
                                <td>{itm.plotId}</td>
                                <td>{itm.plotArea}</td>
                                <td>{itm.executiveName}</td>
                                <td>{itm.state}</td>
                                <td>{itm.landOwnership}</td>
                                <td>{itm.farmerAddress}</td>
                                <td>{itm.landPreparationType}</td>
                                <td>{itm.soilType}</td>
                                <td>{itm.soilTexture}</td>
                                <td>{itm.irrigationSource}</td>
                                <td>
                                  {itm.plotCoordinates &&
                                    JSON.parse(itm.plotCoordinates).map(
                                      (coord, index) => (
                                        <div key={index}>{coord.latitude}</div>
                                      )
                                    )}
                                </td>
                                <td>
                                  {itm.plotCoordinates &&
                                    JSON.parse(itm.plotCoordinates).map(
                                      (coord, index) => (
                                        <div key={index}>{coord.longitude}</div>
                                      )
                                    )}
                                </td>
                                <td>{itm.landMark}</td>
                                <td>
                                  {new Date(
                                    itm.createdDate
                                  ).toLocaleDateString()}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PlotMapping;
